export default {
	xl: 'xl',
	l: 'l',
	m: 'm',
	s: 's',
	xs: 'xs',
	text_xl: 'text-xl'
};
